module.exports = __webpack_public_path__ + "img/reading-3-en.fe05ac85.png";